module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slides"
  }, [_vm._l((_vm.images), function(image, index) {
    return _c('div', {
      staticClass: "slides__slide",
      style: ({
        'animationDelay': ((index * _vm.animationFactor) + "s"),
        'zIndex': _vm.images.length - index,
        'animationDuration': ((_vm.images.length * _vm.animationFactor) + "s"),
        'backgroundImage': index === 0 || _vm.load ? ("url(" + image + ")") : '',
        'visibility': index > 0 ? 'hidden' : 'visible'
      })
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "slides__title"
  }, [_vm._v(_vm._s(_vm.title))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-273b32cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HoverShow.vue
// module id = 383
// module chunks = 2